import { ChangeDetectionStrategy, Component, inject, input, model, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractComponent } from '@spike/scaffolds';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { Trade } from '../../models/trade.model';
import { EtiquetteStoreService } from '../../services/etiquette-service/etiquette-store.service';
import { WalletStoreService } from '../../services/etiquette-service/wallet-store.service';
import { SortingModel } from '../../models/sorting.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-trades-table',
  standalone: true,
  imports: [
    CommonModule, 
    TableModule, 
    TagModule, 
    TooltipModule
  ],
  templateUrl: './trades-table.html'
})
export class TradesTableComponent extends AbstractComponent {
  // Store iniettati per i lookup di Wallet ed Etiquette nel template
  public readonly walletStore = inject(WalletStoreService);
  public readonly etiquetteStore = inject(EtiquetteStoreService);

  items = input.required<Trade[]>();
  sorting = model<SortingModel>(({ orderByClause: 'accounting_date', orderDirection: 'desc' }));
  
  onSelect = output<Trade>();
  public readonly monthNames = [
    'gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno',
    'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre'
  ];

  sort(event: any): void {
    this.sorting.set({ 
      orderByClause: event.field, 
      orderDirection: event.order === 1 ? 'asc' : 'desc' 
    });
  }

}